<template>
<div>
  <v-text-field
      v-if="serviceDiscountType === '₽'"
      v-model.number="localDiscount"
      @input="discountCalc()"
      type="text" background-color="white" hide-details outlined dense class="_inside-input-wrapper" ondragstart="return false;" @focus="$event.target.setSelectionRange(0,5)"
      ref="input"
      :disabled="disabled!==undefined"
      >
    <template v-slot:append>
      <v-select
          :items="moneyOrPercent"
          v-model="serviceDiscountType"
          hide-details dense
          @change="refreshDiscount();"
      ></v-select>
    </template>
  </v-text-field>
  <v-text-field
      v-else
      v-model.number="localDiscount"
      @input="discountCalc()"
      type="text" background-color="white" hide-details outlined dense class="_inside-input-wrapper" ondragstart="return false;" @focus="$event.target.setSelectionRange(0,5)"
      ref="input"
       :disabled="disabled!==undefined">
    <template v-slot:append>
      <v-select
          :items="moneyOrPercent"
          v-model="serviceDiscountType"
          hide-details dense
          @change="refreshDiscount();"
      ></v-select>
    </template>
  </v-text-field>
</div>
</template>

<script>

export default {
  props: [
    'price', 'discount', 'count', 'disabled'
  ],
  data:()=>({
    serviceDiscountType: '%',
    moneyOrPercent: ['₽','%'],
    localDiscount:null,
  }),
  watch:{
    discount(newV,oldV) {
      //console.log(newV,oldV);
      if (parseInt(newV)!==parseInt(oldV)) {
        this.prepareData();
        this.afterUpdateAction();
      } 
    },
    count() {
      this.discountCalc();
    }
  },
  mounted(){
    this.prepareData()
  },
  methods: {
    prepareData(){
      if (this.serviceDiscountType === '%'&&this.price!==undefined)
        this.localDiscount = parseInt(this.price)>0 ? (this.discount/((this.price/100)*this.count)).toFixed(0) : 0;
      else 
        this.localDiscount = this.discount
    },
    discountCalc(){
      this.$tools.debounce(()=>{
        if (this.price !== undefined) {
          let discount = this.serviceDiscountType === '%' ? (this.localDiscount*((this.price/100)*this.count)).toFixed(0) : this.localDiscount;
          this.$emit('update:discount', discount);
        }

        this.afterUpdateAction();
      },1000);
    },
    afterUpdateAction(){
      this.$emit('afterUpdate',{
        type: this.serviceDiscountType,
        discount: this.localDiscount
      });
    },
    refreshDiscount() {
      this.localDiscount = 0;
      this.$emit('update:discount', 0)
      this.afterUpdateAction();

      setTimeout(()=>{
        const textFieldElement = this.$refs.input.$refs.input;
        if (textFieldElement) {
          textFieldElement.setSelectionRange(0,5);
        }
      },300);
    }
  }
}
</script>